var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 22a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 15 19q0-.15.075-.7L8.05 14.2A2.97 2.97 0 0 1 6 15a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 3 12q0-1.25.875-2.125A2.9 2.9 0 0 1 6 9a2.97 2.97 0 0 1 2.05.8l7.025-4.1a1.7 1.7 0 0 1-.062-.338A5 5 0 0 1 15 5q0-1.25.875-2.125A2.9 2.9 0 0 1 18 2q1.25 0 2.125.875T21 5t-.875 2.125A2.9 2.9 0 0 1 18 8a2.97 2.97 0 0 1-2.05-.8l-7.025 4.1q.05.176.063.337Q9 11.801 9 12q0 .2-.012.363-.014.162-.063.337l7.025 4.1A2.97 2.97 0 0 1 18 16q1.25 0 2.125.875T21 19t-.875 2.125A2.9 2.9 0 0 1 18 22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFill);
export default __webpack_public_path__ + "static/media/share_fill.e25654c1e90137dcc8420dedb37c5774.svg";
export { ForwardRef as ReactComponent };